import Vue from 'vue';

export default {
  state: {
    config: {
      max_sms_char: 160,
    },
  },
  getters: {
    chat_center_config(state) {
      return state.config;
    },
  },
  mutations: {
    SET_CONFIG(state, data) {
      const temp = _.pick(data, 
        [
          'close',
          'close_category_id',
          'agent_limit',
          'away_time',
          'chat_category.name',
          'config'
        ]);
      temp.name = (temp.chat_category || {}).name;
      delete temp.chat_category;
      temp.config = temp.config ? {
        ...state.config,
        ...JSON.parse(temp.config),
      } : {
        stopManagement: false,
        assignment: false,
      };
      state.config = temp;
    },
  },
  actions: {
    GET_CONFIG({ commit }) {
      return Vue.axios.get('chats_centers/config')
        .then(({ data }) => {
          if (data) {
            commit('SET_CONFIG', data);
          }
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/chat_center_config.js